import { render, staticRenderFns } from "./daycall.vue?vue&type=template&id=5d6f66a8&scoped=true&"
import script from "./daycall.vue?vue&type=script&lang=js&"
export * from "./daycall.vue?vue&type=script&lang=js&"
import style0 from "./daycall.vue?vue&type=style&index=0&id=5d6f66a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6f66a8",
  null
  
)

export default component.exports